<template>
  <div>
  <!-- <vue-scroll class="card-base card-shadow--medium mb-30" style="height:400px"> -->
    <div class="p-20 flex">
      <div class="box">
        <h4 v-if="title" class="mv-0">{{title}}</h4>
        <h4 v-else class="mv-0">{{ $t('invoices.invoicesTitle') }}</h4>

      </div>
      <div class="box center"></div>
      <div class="box self-flex-end">
        <el-button :icon="loadingIcon" class="mr-5" size="small" @click="refresh" style="float:left;" />
        <el-dropdown v-if="id!=null" >
          <el-button size="small">
            <i class="el-icon-more-outline"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown" size="small">
            <el-dropdown-item :disabled="true"><i class="el-icon-setting"></i>{{$t('invoices.dashboard.configure')}}</el-dropdown-item>
            <el-dropdown-item @click.native="handleDelete" ><i class="el-icon-delete"></i>{{$t('invoices.dashboard.delete')}}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <el-skeleton :count="1  " animated :loading="loading">
      <template slot="template">
        <tableSkeleton  :rows="parseInt((height-250)/40) || 0" :height="height-250" :columnLabel="[{ label:' ', width:50, sortable:false}, {label: $t('common.number'), width:150, sortable:true}, {label: $t('common.customer'), sortable:true}, { label: $t('common.dueDate'), width: 150, sortable:true}, {label: $t('common.amount'), width: 150, sortable:true}, {label: $t('common.status'), sortable:true}]"></tableSkeleton>
      </template>
      <template>
        <invoiceTable :invoices="invoices" class="mb-20" :criterias="criterias" :fields="fields" :height="height-250"></invoiceTable>
      </template>
    </el-skeleton>
    <div class="m-20 flex justify-space-between" style="display:absolute; top:20px;">
      <h4 class="mt-5 mb-0 o-050 fs-14 secondray-text">{{count}} {{ $t('invoices.invoicesFoundOutOf') }} {{totalCount}}</h4>
      <Pagination
        class="mt-5 mb-0 fs-14 secondary-text"
        :current-page="page"
        :total-number-of-page="totalPages"
        @click-previous="clickPrevious"
        @click-next="clickNext" />
    </div>
  <!-- </vue-scroll> -->
</div>
</template>
<script>
import invoiceTable from './invoice-table'
import invoiceAPI from '@/services/API/invoice';
import moment from 'moment-timezone'
import tableSkeleton from '@/components/skeleton/table-skeleton'
import Pagination from '@/components/pagination.vue';
import { mapActions } from 'vuex';

export default {
  name: 'invoice-dashboard-card',
	props: {
    uuid: {
      type: String
    },
    id : {
      type : Number
    },
    position : {
      type : Number,
      required: true
    },
    filters : {
      type : Object
    },
    limit : {
      type : String,
      default : null
    },
    defaultType : {
      type : String,
      default : null
    },
    title : {
      type : String,
      default : null
    },
    criterias : {
      type : Array
    },
    fields : {
      type : Array
    },
    salesReps : {
      type : Array
    },
    customerClasses : {
      type : Array
    },
    productId : {
      type : Number
    },
    height: {
      type: Number
    }
	},
  data() {
    return {
      invoices : [],
      type : 'CONFIRMED',
      loading : false,
      user : null,
      timer : '',
      totalCount : null,
      page : 1,
      totalPages : null,
    };
  },components: {
    invoiceTable,
    tableSkeleton,
    Pagination
  },
	methods: {
    handleDelete(){
      this.deleteDashboard(this.id)
        .then(()=>{
          this.$message({
          message: 'Le canal a été supprimé avec succès.',
          type: 'success'
        });
        })
    },
    clickPrevious () {
      if (this.page > 1) {
          this.page -= 1;
      }
      this.refresh();
    },
    clickNext () {
      if (this.page < this.totalPages) {
        this.page += 1;
        this.refresh();
      }
    },
    fetchInvoices(){
      this.loading =true;
      let params = {};

      params.statusCode = [];
      _.forEach(this.filters, (value, key)=>{
        if(value)params.statusCode.push(key);
      })

      params.reps = this.salesReps?this.salesReps:undefined;
      params.customerClasses = this.customerClasses ? this.customerClasses : undefined;
      params.productId = this.productId ? this.productId : undefined;

      if(this.criterias!=null){
        _.forEach(this.criterias, criteria=>{
          if(criteria.code==='date'){
            if(criteria.selectedOperator==='='){
              params.date=moment().format();
            }else if(criteria.selectedOperator==='>='){
              params.startDate=moment().format('YYYY-MM-DD Z');
            }else if(criteria.selectedOperator==='>'){
              params.startDate=moment().add(1,'day').format('YYYY-MM-DD Z');
            }else if(criteria.selectedOperator==='<'){
              params.endDate=moment().subtract(1,'day').format('YYYY-MM-DD Z');
            }else if(criteria.selectedOperator==='<='){
              params.endDate=moment().format('YYYY-MM-DD Z');
            }
          } else if(criteria.code==='due_date'){
            if(criteria.selectedOperator==='='){
              params.dueDate=moment().format();
            }else if(criteria.selectedOperator==='>='){
              params.startDueDate=moment().format('YYYY-MM-DD Z');
            }else if(criteria.selectedOperator==='>'){
              params.startDueDate=moment().add(1,'day').format('YYYY-MM-DD Z');
            }else if(criteria.selectedOperator==='<'){
              params.endDueDate=moment().subtract(1,'day').format('YYYY-MM-DD Z');
            }else if(criteria.selectedOperator==='<='){
              params.endDueDate=moment().format('YYYY-MM-DD Z');
            }
          }else if(criteria.code==='paid_at'){
            if(criteria.selectedOperator==='='){
              params.paidAt=moment().format();
            }else if(criteria.selectedOperator==='>='){
              params.startPaidAt=moment().format('YYYY-MM-DD Z');
            }else if(criteria.selectedOperator==='>'){
              params.startPaidAt=moment().add(1,'day').format('YYYY-MM-DD Z');
            }else if(criteria.selectedOperator==='<'){
              params.endPaidAt=moment().subtract(1,'day').format('YYYY-MM-DD Z');
            }else if(criteria.selectedOperator==='<='){
              params.endPaidAt=moment().format('YYYY-MM-DD Z');
            }
          }else if(criteria.code==='delay'){
            if(criteria.selectedOperator==='='){
              params.date=moment().subtract(criteria.selectedValue,'day').format('YYYY-MM-DD Z');
            }else if(criteria.selectedOperator==='>='){
              params.delay=criteria.selectedValue;
            }
          }
        })
      }

      params.limit=100;
      params.orderBy="date";
      params.direction="ASC";
      params.page=1;

      params.page = this.page;

      return invoiceAPI.fetchInvoices(params)
        .then(invoices=>{
          this.invoices = invoices.list;
          this.totalCount = invoices.count;
          this.totalPages = invoices.pages;
          this.loading=false;
          this.updateTotalElement({ uuid: this.uuid, totalElement: this.totalCount});
        }).catch((err) => {
          console.log(err);
        })

    },
    _moment(datetime, format='LL'){
      return moment(datetime).format(format);

    },
    date(so){
      if(this.filters){
        let status = _.find(so.status_logs, status=>{return status.code==this.type});
        if(status==null)return false;
        return status.status_log.created_at;
      }else{
        return so.date;
      }

    },
    openInvoice(salesOrderId){
      var index='/invoices/'+salesOrderId;
      this.$router.push(index);
    },
    openCustomer(customerId){
      var index='/customers/'+customerId;
      this.$router.push(index);
    },
    refresh(){
      this.cancelAutoUpdate();
      this.fetchInvoices()
        .then(() => this.createTimer());
    },
    cancelAutoUpdate () { clearInterval(this.timer) },
    createTimer () {
      this.timer = setInterval(this.fetchInvoices, 60000 + (this.position * 2000))
    },
    ...mapActions('users',['fetchAdminUsers']),
    ...mapActions('genericDashboards', ['updateTotalElement', 'deleteDashboard']),
	},
	computed: {
    loadingIcon(){
      if(this.loading)return 'el-icon-loading'
      else return 'el-icon-refresh'
    },
    count(){
      if(this.invoices==null)return 0;
      else return this.invoices.length;

    },
	},
  created(){
    if(this.defaultType!=null){
      this.type = this.defaultType;
    }

    this.fetchInvoices();
    this.createTimer();

  },
  beforeDestroy () {
    this.cancelAutoUpdate();
  }
}
</script>
<style lang="scss" scoped>




</style>
